export default "__VITE_ASSET__DXyh10Xd__"